import React from 'react';
export function AlertBar() {
  const text = '🎉 ¡Aprovechá hoy! Descuento por tiempo limitado 🎉';
  const repeats = 8;
  return <div className="bg-[#FFF0F5] text-dark text-sm font-heading font-medium tracking-wide sticky top-0 z-50 border-b border-primary/10" style={{
    overflow: 'hidden',
    position: 'relative',
    height: '40px'
  }} data-id="element-20">
      <div className="flex whitespace-nowrap animate-marquee items-center absolute top-0 left-0" style={{
      height: '40px'
    }} data-id="element-21">
        {[...Array(repeats)].map((_, i) => <span key={i} className="mx-8 inline-block" data-id="element-22">
            {text}
          </span>)}
      </div>
    </div>;
}